
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './appSlice';
import { persistReducer, persistStore } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import { Persistor } from 'redux-persist/es/types';
import { useDispatch, TypedUseSelectorHook, useSelector } from 'react-redux';

const persistConfig = {
    key: 'root',
    storage: storageSession
}

const persistedReducer = persistReducer(persistConfig, rootReducer)


const store = configureStore({
    reducer: persistedReducer,
    devTools: import.meta.env.VITE_ENV !== 'production',
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        })
});

// persistor.purge(); // Clear expired state slices

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector

export const persistor: Persistor = persistStore(store);

export default store
